import React, { useEffect } from 'react';
import {
  Accordian,
  PageLayout,
} from '~/components';
import usePatient from '~/utils/patient/hook';
import { hasLegalStatus } from '~/utils/patient/identity-access';

import { IdentityPageProvider } from '~/utils/identity/page';
import IdentitySurgeries from '../identity-surgeries';
import Allergies from './allergies';
import PrimaryCareProvider from './primaryCare-provider';
import Immunizations from './immunizations';
import MedicationsAndPharmacies from './medications-&-pharmacies';
import MedicalProblemList from './medical-problem-list';
import Screenings from './screenings';

const HealthInformation = () => {
  const [, patient, actions] = usePatient();

  const pageSpec = {
    title: 'Health Information',
    enableFullPrint: hasLegalStatus(patient),
    enableIndividualPrint: hasLegalStatus(patient),
    panels: [{
      title: 'Primary Care Provider',
      body: <PrimaryCareProvider />,
    }, {
      title: 'Medications & Pharmacies',
      body: <MedicationsAndPharmacies />,
    }, {
      title: 'Allergies',
      body: <Allergies />,
    }, {
      title: 'Immunizations',
      body: <Immunizations />,
    }, {
      title: 'Medical Problem List',
      body: <MedicalProblemList />,
    }, {
      title: 'Surgeries',
      body: <IdentitySurgeries />,
    }, {
      title: 'Screenings',
      body: <Screenings />,
    }],
  };

  useEffect(() => {
    actions.audit('HealthInfo');
  }, []);

  return (
    <PageLayout>
      <IdentityPageProvider pageSpec={pageSpec}>
        {({
          accordianItems,
          expandPanel,
          allPanelsOpen,
          openPanel,
        }) => (
          <Accordian
            openPanel={openPanel}
            allOpen={allPanelsOpen}
            setOpenPanel={expandPanel}
            items={accordianItems}
          />
        )}
      </IdentityPageProvider>
    </PageLayout>
  );
};

export default HealthInformation;
